import { render, staticRenderFns } from "./CorpAdminDirectMatching.vue?vue&type=template&id=6c499866"
import script from "./CorpAdminDirectMatching.vue?vue&type=script&lang=js"
export * from "./CorpAdminDirectMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports